var _line, _circle, _circle2, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTelevision(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 140,
    viewBox: "0 0 100 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 50,
    y1: 6,
    x2: 50,
    y2: 43,
    stroke: "#B31B34",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 4,
    r: 4,
    fill: "#B31B34"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 90,
    r: 50,
    fill: "#B31B34"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.3333 98.3333H66.6666V75.4167H33.3333V98.3333ZM52.0833 102.5V106.667H60.4166V110.833H39.5833V106.667H47.9166V102.5H31.2333C30.9597 102.498 30.6891 102.443 30.4371 102.336C30.185 102.23 29.9565 102.075 29.7645 101.88C29.5725 101.685 29.4209 101.454 29.3183 101.201C29.2157 100.947 29.1641 100.676 29.1666 100.402V73.3479C29.1666 72.1896 30.1145 71.25 31.2333 71.25H68.7666C69.9083 71.25 70.8333 72.1854 70.8333 73.3479V100.402C70.8333 101.56 69.8853 102.5 68.7666 102.5H52.0833Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelevision);
export default __webpack_public_path__ + "static/media/television.b7ae26ad675d4a215fbc7374c173dc4d.svg";
export { ForwardRef as ReactComponent };